export const formatFullInr = value => `₹ ${Number(value || 0).toLocaleString('en-IN')}`;

export const formatShortInr = value => {
  const amount = Number(value || 0);
  const lakhs = Math.round(amount / 1e3) / 100;
  if (lakhs >= 100) return `₹ ${(Math.round(amount / 1e5) / 100).toFixed(2)} Cr`;
  if (amount >= 1e5) return `₹ ${lakhs.toFixed(2)} L`;
  return formatFullInr(amount);
};
